import i18n from '@/localization/i18n';

// i18n 語言碼 → 後端多語欄位 key（通知 title/content 等回傳 { zh_tw, en, jp }）
const LANG_KEY_MAP = { zh: 'zh_tw', en: 'en', ja: 'jp' };

/**
 * 從後端多語物件取出目前語言的字串。
 * 對應方式：zh→zh_tw、en→en、ja→jp。
 * 找不到目前語言時 fallback 到 zh_tw（與 i18n fallbackLng 一致的預設語言）。
 *
 * @param {{ zh_tw?: string, en?: string, jp?: string }} field 多語物件
 * @returns {string}
 */
export function localizeField(field) {
  if (!field || typeof field !== 'object') return '';
  const key = LANG_KEY_MAP[i18n.language] || 'zh_tw';
  return field[key] ?? field.zh_tw ?? '';
}
